import Layout from 'components/layout';
import { Routes, useLocation } from 'react-router-dom';
import { SetRoutes } from 'components';
import routes from './routes';

const BoardDocsPage = () => {
  return (
    <Layout>
      <SetRoutes routes={routes} />
    </Layout>
  );
};

export default BoardDocsPage;
